module.exports = "<td class=\"jurisdiction-enabled\">\r\n    <input type=\"checkbox\" class=\"slider\" value={{Model.Enabled}} id={{Model.JurisdictionId}} {{#Model.Enabled}}checked{{/Model.Enabled}}/>\r\n</td>\r\n<td class=\"jurisdiction-name\">\r\n    <img src=\"assets/images/flags/32/{{Model.IconUrl}}\" title=\"{{Model.Jurisdiction}}\" width=\"24\" height=\"24\"/>\r\n    {{Model.Jurisdiction}}\r\n</td>"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/alerts-jurisdiction.html
// module id = 367
// module chunks = 1